module.exports = __webpack_public_path__ + "static/2_3_game-tree-2-0259fe81781580c59c8403d72593c77d.svg";